module.exports = __webpack_public_path__ + "img/thumbs-up.f279ad61.svg";